export const meKeys = {
  debugAccess: ['me', 'debug-access'] as const,
  estimateResponseInfoMinimal: (responseId: string) =>
    ['me', 'estimate-responses', responseId, 'info-minimal'] as const,
  estimates: ['me', 'estimates'] as const,
  me: ['me'] as const,
  passengers: ['me', 'passengers'] as const,
  profile: ['me', 'profile'] as const,
  reservation: (reservationId: string) => ['me', 'reservations', reservationId] as const,
}
